import { AxiosRequestConfig } from "axios";
import ApiResponse, { isError } from "utils/api/models/api-response";
import ApiService from "utils/api/api-service";
import { ApiErrorNotification } from "utils/ui/notificationService";

class CalenderService extends ApiService {
  constructor(config?: AxiosRequestConfig) {
    super({
      baseURL: process.env.REACT_APP_API_URL,
      ...config,
    });
  }
  public async getCalenderTicket(params: {start_date: string, end_date: string}): Promise<any> {
    // const params = new URLSearchParams();
    // params.append('page', page);
    // params.append('items_per_page', '18');
    // if (search) params.append('filter[search]', search);

    // return this.get(`/api/holidays?${params.toString()}`);
    return this.get(`/api/calender_tickets`, {params});
  }
}

const calenderService = new CalenderService();
export const GetCalenderTicket = async ({start_date, end_date}: {start_date: string, end_date: string}) => {
  const result: any = await calenderService.getCalenderTicket({start_date, end_date});
  if (isError(result)) {
    ApiErrorNotification(result);
    throw result;
  } else {
    return result;
  }
};